import { atom } from 'jotai';

export type MCPBridgeLogLevel = 'success' | 'info' | 'warn' | 'error';

export type MCPBridgeSpeaker = 'user' | 'assistant';

type MCPBridgeStandardLogEntry = {
  kind: 'log';
  id: number;
  timestamp: number;
  level: MCPBridgeLogLevel;
  message: string;
};

type MCPBridgeSpeechEntry = {
  kind: 'speech';
  id: number;
  timestamp: number;
  speaker: MCPBridgeSpeaker;
  message: string;
};

export type MCPBridgeLogEntry = MCPBridgeStandardLogEntry | MCPBridgeSpeechEntry;

export const mcpBridgeLogAtom = atom<MCPBridgeLogEntry[]>([]);
